import Util from '@/assets/libs/util.js'
import requestModule from '../libs/requestModule'
let promotionalCampaigns = []

const fetchPromotionalCampaigns = async function () {
  // verifica se há campanhas promocionais disponíveis
  const payload = {
    subsidiaryCode: Util.getGeneralInfo().subsidiaryCode
  }
  const campaigns = await requestModule.postRequest('menu/offers', payload)
  if (campaigns && campaigns.data && !campaigns.error) {
    promotionalCampaigns = campaigns.data
  }
  if (!campaigns || campaigns.error) {
    const message = campaigns.message || 'Não foi possivel ober as campanhas promocionais'
    console.log(message)
  }
  if (promotionalCampaigns === 0) {
    console.log('Não há campanhas promocionais disponiveis')
  }
  return promotionalCampaigns
}

const checkPossiblePromotionalCampaign = async function (prod) {
  /* verifica se pelo menos 2 itens do combo fazem parte de alguma campanha promocional */
  let count = 0
  for (let i = 0; (i < promotionalCampaigns.length); i++) {
    // checa o produto principal
    if (promotionalCampaigns[i].products.includes(prod.productCode)) {
      count = 1
    }
    // checa as escolhas no combo
    for (let c = 0; c < prod.productCombo.length; c++) {
      const comboChosen = prod.productCombo[c]
      if (promotionalCampaigns[i].products.includes(comboChosen.subItemCode)) {
        count++
      }
      if (count >= 2) {
        return true
      }
      // checa as escolhas no combo do combo
      if (comboChosen.choosen) {
        Object.keys(comboChosen.choosen).forEach((e) => {
          comboChosen.choosen[e].forEach((cc) => {
            if (promotionalCampaigns[i].products.includes(cc.subItemCode)) {
              count++
            }
            if (count >= 2) {
              return true
            }
          })
        })
      }
    }
  }
  if (count >= 2) {
    return true
  }
  console.log('Não ha combinações possiveis para campanha promocinal')
  return false
}

const updatePricesPromotionalCampaigns = async function (prod) {
  if (promotionalCampaigns.length === 0) {
    console.log('Não há campanhas ativas')
    return prod
  }
  if (prod.productCombo.length === 0) {
    return prod
  }
  const possibleCampaing = checkPossiblePromotionalCampaign(prod)

  if (possibleCampaing) {
    /* caso tenha pelo menos 2 produtos participantes de 1 campanha promocional,
            envia todos os itens do combo para a interface calcular os novos preços */
    console.log('Há produtos elegiveis a campanha promocional')
    const payload = buildRequest(prod)
    let newPrices = await requestModule.postRequest('menu/offersByCombinations', payload)
    if (!newPrices || newPrices.error || !newPrices.data || newPrices.data.length === 0) {
      const message = newPrices.message || 'Não foi possivel obter os preços dos produtos da campanha promovional'
      console.log(message)
      return prod
    }
    newPrices = newPrices.data
    prod = updatePrices(prod, newPrices)
  }
  return prod
}

const buildRequest = function (prod) {
  /* Monta o payload com todos os itens do combo */
  // eslint-disable-next-line
  if (!prod.hasOwnProperty('discountbkp')) {
    /* grava um backup dos preços originais do produto principal
            caso o consumidor altere o combo no carrinho */
    /* prod.discountbkp = prod.discount
        prod.additionbkp = prod.addition
        prod.pricebkp = prod.price
        prod.fullPrice = prod.fullPrice */
  }
  const payload = {
    subsidiaryCode: Util.getGeneralInfo().subsidiaryCode,
    clientCode: '',
    consumerType: '',
    productCode: prod.productCode,
    productsPrint: prod.productPrint,
    productsName: prod.productName,
    discount: prod.discountbkp || prod.discount,
    addition: prod.additionbkp || prod.addition,
    price: prod.pricebkp || prod.price,
    fullPrice: prod.fullPricebkp || prod.fullPrice,
    selectedProducts: getComboSelectedItems(prod.productCombo)
  }
  return payload
}
function getComboSelectedItems (products) {
  const result = []
  products.forEach(e => {
    const product = {
      productCode: e.subItemCode,
      productsPrint: e.subItemProductPrint,
      groupPrint: e.groupPrint,
      productName: e.subItemName,
      price: e.pricebkp || e.price,
      discount: e.discountbkp || e.discount,
      addition: e.additionbkp || e.addition,
      fullPrice: e.fullPricebkp || e.fullPrice,
      childItems: e.choosen ? getComboComboSelectedItems(e.choosen) : []
    }
    result.push(product)
  })
  return result
}
function getComboComboSelectedItems (products) {
  const result = []
  Object.keys(products).forEach((e) => {
    products[e].forEach((p) => {
      const product = {
        productCode: p.subItemCode,
        productName: p.subItemName,
        groupCode: p.e,
        discount: p.discountbkp || p.discount,
        addition: p.additionbkp || p.addition,
        price: p.pricebkp || p.price,
        fullPrice: p.fullPricebkp || p.fullPrice
      }
      result.push(product)
    })
  })
  return result
}
function updatePrices (prod, newPrices) {
  /* Pega os preços recebidos da request menu/offersByCombinations e aplica nos itens do combo para ir ao carrinho */
  // eslint-disable-next-line
  if (!prod.hasOwnProperty('discountbkp')) {
    /* Faz um backup dos preços originais caso o usuário altere os itens no carrinho */
    prod.discountbkp = prod.discount
    prod.additionbkp = prod.addition
    prod.pricebkp = prod.price
    prod.fullPricebkp = prod.fullPrice
  }
  // aplica os novos preços no produto principal
  prod.discount = newPrices.discount
  prod.addition = newPrices.addition
  prod.price = newPrices.price
  prod.fullPrice = newPrices.fullPrice

  for (let i = 0; i < prod.productCombo.length; i++) {
    // eslint-disable-next-line
    if (!prod.productCombo[i].hasOwnProperty('discountbkp')) {
      prod.productCombo[i].discountbkp = prod.productCombo[i].discount
      prod.productCombo[i].additionbkp = prod.productCombo[i].addition
      prod.productCombo[i].pricebkp = prod.productCombo[i].price
      prod.productCombo[i].fullPricebkp = prod.productCombo[i].fullPrice
    }
    // aplica os novos preços nos produtos do combo
    prod.productCombo[i].discount = newPrices.selectedProducts[i].discount
    prod.productCombo[i].addition = newPrices.selectedProducts[i].addition
    prod.productCombo[i].price = newPrices.selectedProducts[i].price
    prod.productCombo[i].fullPrice = newPrices.selectedProducts[i].fullPrice

    if (prod.productCombo[i].choosen) { // childItems
      // aplica os novos preços nos produtos do combo do combo
      Object.keys(prod.productCombo[i].choosen).forEach((gCode) => {
        prod.productCombo[i].choosen[gCode].forEach((cCombo, idx) => {
          // eslint-disable-next-line
          if (!cCombo.hasOwnProperty('discountbkp')) {
            cCombo.discountbkp = cCombo.discount
            cCombo.additionbkp = cCombo.addition
            cCombo.pricebkp = cCombo.price
            cCombo.fullPricebkp = cCombo.fullPrice
          }
          cCombo.discount = newPrices.selectedProducts[i].childItems[idx].discount
          cCombo.addition = newPrices.selectedProducts[i].childItems[idx].addition
          cCombo.price = newPrices.selectedProducts[i].childItems[idx].price
          cCombo.fullPrice = newPrices.selectedProducts[i].childItems[idx].fullPrice
        })
      })
    }
  }
  console.log('Precos da campanha promocional aplicados')
  return prod
}
export default {
  fetchPromotionalCampaigns,
  updatePricesPromotionalCampaigns
}
